<template>
    <div class="info-tab-container">
        <InfoCard
            v-for="([dataKey, dataValue], dataIndex) in computedData"
            :key="`data-${dataIndex}`"
            :title="dataKey"
        >
            <InfoBox
                v-for="([key, keyValue], keyIndex) in getEntries(dataValue)"
                :card="dataKey"
                :key="`order-${keyIndex}-${key}`"
                :title="keyValue.label || key"
                :isDate="isDateString(keyValue.value)"
                :data="keyValue"
            />
        </InfoCard>

        <InfoCard title="Observations">
            <div
                v-if="hasObservations"
                class="observation-box"
                v-html="data.Observations"
            />
            <div v-else class="empty-observations">
                <feather-icon icon="FileTextIcon" size="18" class="mr-50 text-muted" />
                <span>Nenhuma observação registrada</span>
            </div>
        </InfoCard>
    </div>
</template>

<script>
    import { mapMutations } from "vuex";
    import InfoCard from "./components/InfoCard";
    import InfoBox from "./components/InfoBox";

    export default {
        name: "InfoTab",
        components: {
            InfoCard,
            InfoBox
        },
        props: {
            data: {
                type: Object,
                default: () => ({})
            }
        },
        computed: {
            computedData() {
                if (!this.data || Object.keys(this.data).length === 0) {
                    return [];
                }
                const array = Object.entries(this.data);
                // Remove Observations since it is handled by the dedicated card below
                const filtered = array.filter(([key]) => key !== "Observations");
                // Hide Attributes if empty
                return filtered.filter(([key, val]) => {
                    if (key === "Attributes") {
                        if (!val) return false;
                        if (Array.isArray(val)) return val.length > 0;
                        if (typeof val === "object") return Object.keys(val).length > 0;
                        return false;
                    }
                    return true;
                });
            },
            hasObservations() {
                const obs = this.data?.Observations;
                if (!obs) return false;
                const trimmed = String(obs).replace(/<[^>]*>/g, "").trim();
                return trimmed !== "" && trimmed !== "-" && trimmed !== "null";
            }
        },
        mounted() {
            this.UPDATE_FLAG_SHOW_OVERLAY(false);
        },
        methods: {
            ...mapMutations("app", ["UPDATE_FLAG_SHOW_OVERLAY"]),
            isDateString(string) {
                if (!string || typeof string !== "string") return false;

                return !isNaN(Date.parse(string)) && /^\d{4}-\d{2}-\d{2}/.test(string);
            },
            getEntries(dataValue) {
                if (Array.isArray(dataValue)) {
                    return dataValue.map((item, index) => [index.toString(), item]);
                }
                return Object.entries(dataValue || {});
            }
        }
    };
</script>

<style lang="scss" scoped>
    .info-tab-container {
        flex-grow: 1;
        z-index: 9999;
        display: flex;
        flex-direction: column;
        padding: 4px 29px 30px;
        width: 100%;

        .observation-box {
            background: #fbf9f8;
            border: 1px solid #e8e2de;
            border-radius: 8px;
            padding: 14px 18px;
            font-size: 14px;
            line-height: 22px;
            color: #3e3733;
            max-width: 100%;
            word-break: break-word;
        }

        .empty-observations {
            display: flex;
            align-items: center;
            background: #fafafa;
            border: 1px dashed #dcd3cd;
            border-radius: 8px;
            padding: 14px 18px;
            font-size: 13.5px;
            color: #8c827a;
            font-style: italic;
        }
    }

    @media (max-width: 768px) {
        .info-tab-container {
            padding: 0 16px 20px !important;
        }
    }
</style>
